<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19IXNdO/cover.jpeg?1684305911396" alt="This image is the cover for the book Kylin Divine Seal, Volume 8"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kylin Divine Seal, Volume 8
      </h1>
      <p class="bookDescription body article font2">
        <p>In the Genuine Force, disaster followed after calamity. Within the vast universe, there were tens of thousands of races.</p><p></p><p>And that endless star field was the direction in which countless living creatures struggled for their entire lives.</p><p></p><p>And to see how the youth would join hands with the Qilin King to leave the barren Lost Continent.</p><p></p><p>The Genuine Force, the War Demon, the Star Domain, and the Foreign World!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Li JiaKaiShao, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e57890b4